import type { AdElementWidget, AdElementWidgetParam } from '@adflow/types';

type WidgetData = AdElementWidget['data'];

/** The widget input that takes an event, filled from the ad's own event when the box is ticked. */
export const AD_EVENT_PARAM: AdElementWidgetParam = {
  name: 'event_sr_id',
  value: '',
  dataPoint: 'EVENT_SR_ID',
};

export const isAdEventParam = (param: AdElementWidgetParam) => param.name === AD_EVENT_PARAM.name;

/** Whether the widget's event is filled from the ad's own event. */
export const showsAdEvent = (data: WidgetData) =>
  data.params.some((param) => isAdEventParam(param) && Boolean(param.dataPoint));

/**
 * Whether the widget takes an event: its link names `event_sr_id`, as a Content Studio link names
 * the input its widget is built for. Any other widget, such as a standings widget taking
 * `season_sr_id`, cannot use the ad's event: the served ad would refuse it and show the fallback
 * image. A link that cannot be read takes no event.
 */
export function takesEvent(url: string): boolean {
  try {
    return new URL(url).searchParams.has(AD_EVENT_PARAM.name);
  } catch {
    return false;
  }
}
